





  




  
  /*
  window.alert = function() {};
		alert = function() {};
      */
  

  
  
  
    
  

//Cookies
var transition = 300;

function getCookie(name) {
    var cookie = document.cookie;
    var prefix = name + "=";
    var begin = cookie.indexOf("; " + prefix);
    if (begin == -1) {
        begin = cookie.indexOf(prefix);
        if (begin !== 0) return 0;
    } else {
        begin += 2;
        var end = document.cookie.indexOf(";", begin);
        if (end == -1) {
        end = cookie.length;
        }
    }
  
  console.log('getCookie('+name+'), result: ' + unescape(cookie.substring(begin + prefix.length, end)));
  
    return unescape(cookie.substring(begin + prefix.length, end));
} 

        function readCookie(name) {
            var nameEQ = name + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
            }
            return null;
        }

function checkCookie(cname) {
    var username = readCookie(cname);
  console.log('checkCookie('+cname+')');
    if (username !== '' && username !== null) {
      console.log('cookie is here. Value: '+ readCookie(cname));
return 1;
    } else {
console.log('cookie is not here');
      return 0;
    }
  
}

function deleteCookie(name){
   
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
 
  console.log('deleteCookie('+name+')');
  
}

function setCookie(cname, cvalue) {

 var exdays = "10000";
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  
  console.log('setCookie('+cname+', '+cvalue+')');
}

//Atrributes & URL

function checkForAttr(attr) {
        if (typeof attr !== typeof undefined && attr !== false) {
            var result = 1;
        } else {
            var result = 0;
        }
  return result;
  
  console.log('checkForAttr('+attr+'); result: ' + result);
  
    }

  

  
function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
  
  console.log('getUrlParameter('+sParam+'); result:' + sParameterName[1] === undefined ? true : sParameterName[1] );
  
};

//Price & Numbers & Text

    function priceToNumber(price) {
        var number = Number(price.replace(/[^0-9\-]+/g, ""));
      
      console.log('priceToNumber('+price+'); result:' + number);
      
        return number;
    }

    function textToNumber(number) {
        var number = Number(number.replace(/[^0-9\.-]+/g, ""));
      
      console.log('textToNumber('+number+'); result:' + number);
      
        return number;
    }

    function numberToPrice(number) {
      var currency = '£';
        var realPrice = (number / 100).toFixed(2);
        var price = currency + "" +realPrice;
      
      if(price.indexOf('.00') > -1){
       price.replace('.00', ''); 
      }
      console.log('numberToPrice('+number+'); result:' + price);
      
        return price;
    }

      function randomNum(min, max) {
        console.log('randomNum('+min+', '+max+')');
    return Math.floor(Math.random() * (max - min + 1) + min);
  }
  
    function increment(first, last, elem){
    
    if(first > last){
     var smaller = last;
      var bigger = first;
    }
    else{
     var smaller = first;
      var bigger = last;
    }
      
   elem.each(function () {
    $(this).prop('Counter',smaller).animate({
        Counter: bigger
    }, {
        duration: 3000,
        easing: 'swing',
        step: function (now) {
            $(this).text(Math.ceil(now));
        }
    });
}); 
  }

    
    function capitalize(str){
      
    console.log('capitalize('+str+')');
 var result = str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
    console.log('capitalize(str): ' + result);
    return result;
}
  
  function camelcase(str) {
    console.log('camelcase('+str+')');
  return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function(match, index) {
    if (+match === 0) return ""; // or if (/\s+/.test(match)) for white spaces
    return index == 0 ? match.toLowerCase() : match.toUpperCase();
  });
}
  
//Shopify Products

    Shopify.queue = [];

    Shopify.moveAlong = function() {   
      var request = Shopify.queue.shift();
            Shopify.addItem(request.variantId, request.quantity, request.properties, Shopify.moveAlong);
       
      
        //ajaxAddSuccess();
      
      //console.log('Shopify.moveAlong = function()');
      
    };

        Shopify.updateAlong = function() {
          var request = Shopify.queue.shift();
     Shopify.changeItem(request.variantId, request.quantity, Shopify.updateAlong);
  

        //ajaxAddSuccess();
    
      console.log('Shopify.updateAlong = function()');
      
};
  
     Shopify.removeAlong = function() { 
       var request = Shopify.queue.shift();
     Shopify.removeItem(request.variantId, Shopify.updateAlong);
  
  // If we still have requests in the queue, let's process the next one.
  if (Shopify.queue.length) {
  }
      else {
      }

          console.log('Shopify.removeAlong = function()');
      
          
};
  
  function updateCartTotal(){
    setTimeout(function(){
 jQuery.getJSON('/cart.js', function(cart) {
    for(var i=0; i<cart.items.length; i++){
      var item = cart.items[i];
      var elem = $('.product-' + item.id+' .money');
      elem.html(Shopify.formatMoney(item.price*item.quantity));
      $('.cart__subtotal').html(Shopify.formatMoney(cart.total_price));
    };
  });
      
    }, 300);
    
    console.log('updateCartTotal()');
      
};

  function updateCartnumber(cart){
    if(cart){
    $('#CartCount [data-cart-count]').text(cart.item_count);
  }
    else{
    
        setTimeout(function(){
          
 jQuery.getJSON('/cart.js', function(cart) {
  })
       .done(function(cart) {
    

   console.log('updateCartnumber(); qty: ' + cart.item_count + '; #CartCount length: ' + $('#CartCount').length);
   
   
   $('#CartCount [data-cart-count]').text(cart.item_count);
  })             
    }, 300);
    }
  }
  
    Shopify.addItem = function(id, qty, properties) {
        var params = {
            quantity: qty,
            id: id
        };
        if (properties != false) {
            params.properties = properties;
        }
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: params,
            async: false,
            success: function() {
                //ajaxAddSuccess();
            },
            error: function() {
               console.log('Error adding to cart');
            }
        });
 
    }

    Shopify.onCartUpdate = function(cart) {
  alert('There are now ' + cart.item_count + ' items in the cart.');
};  
 
  console.log(Shopify);
  
    function removeItem(id) {
push_to_queue(id, 0);
          Shopify.updateAlong();
          
          console.log('removeItem(id); id:' + id);
    
    }

    function push_to_queue(variantID, quantity, properties) {
        Shopify.queue.push({
            variantId: variantID,
            quantity: quantity,
            properties: properties
        });
      //console.log('push_to_queue(variantID, quantity, properties), values:'+ variantID +', '+quantity + ', '+ properties);
    
    }

  function clearCart() {
       Shopify.clear(function(){
    console.log('Cart cleared');
  });
      
      console.log('clearCart()');

}
  
function callback() {
        //window.location.href = "/cart";
      console.log('callback()');
    }

  
  function ajaxAddSuccess(){
    
    $('.item-total-price, .cart__subtotal').addClass('ajax-loading');
    
    setTimeout(function(){
          
 jQuery.getJSON('/cart.js', function(cart) {
  })
       .done(function(cart) {
   
   console.log('ajax download done');
   updateCartnumber(cart);
    $('.cart__subtotal').text(numberToPrice(cart.total_price));
   $('.cart__subtotal').removeClass('ajax-loading');
   var i;
   
   for(i = 0; i < cart.items.length; i++){
    var itemId = cart.items[i].variant_id;
     
     $('.item-holder[data-id="'+itemId+'"] .item-total-price').text(numberToPrice(cart.items[i].line_price));
   $('.item-holder[data-id="'+itemId+'"] .item-total-price').removeClass('ajax-loading');
     console.log('itemId: ' + itemId);
   }
  })             
    }, 600);
  }
  
  //form validation

    function checkCheckbox(elem) {

        if (!elem.is(':checked')) {
            elem.parents('.item').removeClass('success').addClass('error');
            console.log(invalid + ' invalid');
            return 1;

        } else {
            elem.parents('.item').addClass('success').removeClass('error');
            return 0;

        }

console.log('checkCheckbox(elem)');
    }

    function checkEmail(elem) {

        var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;

        var val = elem.val();

        if (!emailReg.test(val) || val == '') {

            elem.removeClass('success').addClass('error');

            return 1;

        } else {

            elem.addClass('success').removeClass('error');

            return 0;

        }
console.log('checkEmail(elem)');

    }

    function checkPattern(elem) {

        if (elem.is(":invalid")) {

            elem.removeClass('success').addClass('error');

            return 1;
        } else {

            elem.addClass('success').removeClass('error');

            return 0;
        }

console.log('checkPattern(elem)');
    }

    function checkTextInputs(elem) {

        var val = elem.val().replace(/ /g, '');

        if (val == undefined || val == 'undefined' || val.length == 0) {

            elem.removeClass('success').addClass('error');
            return 1;
        } else {

            elem.addClass('success').removeClass('error');

            return 0;

        }

console.log('checkTextInputs(elem)');
    }

    function checkRequired(elem) {

        var parent = elem.parents('form');

        parent.find('input[required]:not([type="checkbox"]):not([type="email"]):not([pattern]):visible').each(function() {

            checkTextInputs($(this));

        })

        parent.find('input[type="checkbox"][required]:visible').each(function() {

            checkCheckbox($(this));
        })

        parent.find('input[type="email"][required]:visible').each(function() {

            checkEmail($(this));

        })

        parent.find('input[pattern][required]:visible').each(function() {

            checkPattern($(this));

        })

        invalid = parent.find('.error').length;

        console.log(invalid + ' invalid');
        if (invalid > 0) {

            if (invalid == 0) {
                $('.add-to-cart')
                    .text(addToCartText)
                    .removeClass('disabled');
            } else {
                $('.add-to-cart')
                    .text(addToCartError)
                    .addClass('disabled');
            }

            parent.find('.errors-wrapper,  .errors-wrapper .empty-fields').removeClass('hide');

            console.log('Empty fields: ' + invalid);

            parent.find('.error[required][pattern]').change(function() {
                console.log(invalid + ' invalid');

                checkPattern($(this));
                invalid = $(this).parents('form').find('.error').length;

                if (invalid == 0) {
                    $('.add-to-cart')
                        .text(addToCartText)
                        .removeClass('disabled');
                } else {
                    $('.add-to-cart')
                        .text(addToCartError)
                        .addClass('disabled');
                }
                console.log(invalid);

            })

            parent.find('.error[required][type="email"]').change(function() {
                console.log('email changed');
                checkEmail($(this));
                invalid = $(this).parents('form').find('.error').length;

                if (invalid == 0) {
                    $('.add-to-cart')
                        .text(addToCartText)
                        .removeClass('disabled');
                } else {
                    $('.add-to-cart')
                        .text(addToCartError)
                        .addClass('disabled');
                }
                console.log(invalid);

            })

            parent.find('.error[required][type="checkbox"]').change(function() {
                console.log('checkbox changed');
                checkCheckbox($(this));
                invalid = $(this).parents('form').find('.error').length;

                if (invalid == 0) {
                    $('.add-to-cart')
                        .text(addToCartText)
                        .removeClass('disabled');
                } else {
                    $('.add-to-cart')
                        .text(addToCartError)
                        .addClass('disabled');
                }
                console.log(invalid);

            })

            parent.find('.error[required]:not([type="checkbox"]):not([type="email"]):not([pattern]):visible').change(function() {
                console.log('inputText changed');
                checkTextInputs($(this));
                invalid = $(this).parents('form').find('.error').length;

                if (invalid == 0) {
                    $('.add-to-cart')
                        .text(addToCartText)
                        .removeClass('disabled');
                } else {
                    $('.add-to-cart')
                        .text(addToCartError)
                        .addClass('disabled');
                }

                console.log(invalid);

            })

        }

        return invalid;
      
      
console.log('checkRequired(elem)');
    }

//preventing input number to surpass the min and max values
    
    $('input[type="number"]').bind('input', function(){
      
      var clearedValue = $(this).val().replace(/^0+/, '');
      
      if( $(this).val() !== clearedValue){
        $(this).val(clearedValue);
      }
      
      if($(this).val() > Number( $(this).attr('max'))){
        $(this).val($(this).attr('max'));
      }
      else if($(this).val() < Number( $(this).attr('min'))){
        $(this).val($(this).attr('min'));
      } 
      
      console.log("$('input[type='number']').bind('input', function(){}");
    })

//element effects

function fadeEffects(hideElem, showElem){
      
      if(hideElem.length > 0){
  hideElem.fadeOut(300);
    
    setTimeout(function(){
      if(showElem.length > 0){
      showElem.fadeIn(300);
      }
    }, 300)
      }
      else{
        showElem.fadeIn(300);
      }
     console.log('fadeEffects(hideElem, showElem)');
    
}

function slideEffects(hideElem, showElem){
  if(hideElem.length > 0){
  hideElem.slideUp(300);
  }
showElem.slideDown(300);
console.log('slideEffects(hideElem, showElem)');
    
}


  
function typeWriter(elem, txt, repeat) {
    var i = 0;
  if(txt == ''){
  var txt = $(elem).text();
  }
var speed = 150; /* The speed/duration of the effect in milliseconds */

  elem.addClass('typewriter');
  
  function typeWrite(){
  if (i < txt.length > 0){
    $(id).html($(elem).html() + '' + txt.charAt(i));
    i++;
                            
     if( $(elem).text() == txt)   {
       if(repeat != 0){
               i = 0;
                            setTimeout(function(){
                              $(elem).text('')
    i = 0;
      typeWriter();
    }, 2000);
       }
       }
       else{
    var x = setTimeout(typeWrite, speed);
  }
  }
}
}

  
  //same height of elements
  
  function sameHeight(obj, child){
    obj.css('height', 'auto');
    var maxHeight = 0;
    obj.each(function(){
      if($(this).outerHeight() > maxHeight){
        maxHeight = $(this).outerHeight();
        console.log('bigger height: ' + maxHeight +'---'+$(this).outerHeight())
      }
      else{
       console.log('height not bigger: ' + maxHeight +'---'+$(this).outerHeight())
       
      }
      
    })
    obj.css('height', maxHeight);
    
    obj.each(function(){
      var diff = ($(this).height() - $(this).find('.'+child+'').outerHeight())/2;
      
      $(this).find('.'+child+'').css('top', diff);
    })
    
    console.log('sameHeight(obj, child)');
  }
  
function smoothLoad(){
//requires css body.loading: opacity: 0;
      $('body').removeClass('loading');

window.onbeforeunload = function(){

    
 $('body').addClass('loading');
 
  
}

console.log('smoothLoad()');
}

//overflow Functions

  var usedHideScroll = 0;
  
    var scrollValue = 0;

    function hideScroll(){
      scrollValue = $(document).scrollTop();
      $('html, body').addClass('no-overflow').css('top', -scrollValue).css('position', 'fixed');
      
      console.log('function hideScroll('+scrollValue+')');
      
      usedHideScroll = 1;
    }
    
       function showScroll(){
         $('html, body').css('position', 'inherit').removeClass('no-overflow').css('top', 0);
         
         $('html, body').animate({
        scrollTop: scrollValue},
        0);
         console.log('function showScroll('+scrollValue+')');
         
         usedHideScroll = 0;
      }
  
  function toggleScroll(){
    if($('html').hasClass('no-overflow')){
      showScroll();
    console.log('toggleScroll(); showing scroll');
    }
    else{
      hideScroll();
    console.log('toggleScroll(); hiding scroll');
    }
    
  }
  
  


  
  
  //date functions
  
     function compareToToday(dateText) {
// date is dd.mm.yyyy
        var inputDate = dateText.split(".");
        var today = new Date();
        inputDate = new Date(inputDate[2], inputDate[1] - 1, inputDate[0], 0, 0, 0, 0);
        today = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0, 0);
       
       console.log('compareToToday('+dateText+'); result: ' + inputDate < today );
       
        return inputDate < today;
          //inputDate < today, if true, result is 'False'
};

     function compareDates(date1, date2) {
// date is dd.mm.yyyy
        var inputDate1 = date1.split(".");
var inputDate2 = date2.split(".");
        inputDate1 = new Date(inputDate1[2], inputDate1[1] - 1, inputDate1[0], 0, 0, 0, 0);
        inputDate2 = new Date(inputDate2[2], inputDate2[1] - 1, inputDate2[0], 0, 0, 0, 0);
       
       console.log('compareDates('+date1+', '+date2+'); result: '+ inputDate1 < inputDate2);
       
       
        return inputDate1 < inputDate2;
          //date1 < date2, if true, result is 'False'
};

//distance between dates

  function daysDistance(firstDate,secondDate){
                
                 var startDay = new Date(firstDate);
                  var endDay = new Date(secondDate);
                  var millisecondsPerDay = 1000 * 60 * 60 * 24;

                  var millisBetween = startDay.getTime() - endDay.getTime();
                  var days = millisBetween / millisecondsPerDay;

                  // Round down.
                  return Math.abs( Math.floor(days));
    
    console.log('daysDistance('+firstDate+','+secondDate+'); result: ' + Math.abs( Math.floor(days)));
       
}

    function dateToWeekday(date){
      var d = new Date(date);
var weekday = new Array(7);
weekday[0] =  "Sunday";
weekday[1] = "Monday";
weekday[2] = "Tuesday";
weekday[3] = "Wednesday";
weekday[4] = "Thursday";
weekday[5] = "Friday";
weekday[6] = "Saturday";

      console.log('dateToWeekday('+date+')');
      
return weekday[d.getDay()];
    }
    
      
  //other functions
  
function stringToMath(string){
  
  console.log('stringToMath('+string+'); result: ' + eval(string));
  
return eval(string);
}
  
function copyToClipboard(element) {
 var $temp = $("<input>");
 $("body").append($temp);
 $temp.val($(element).val()).select();
 document.execCommand("copy");
 $temp.remove();
  
  console.log('copyToClipboard(element)');
  
}
  
      function render(props) {
  return function(tok, i) { return (i % 2) ? props[tok] : tok; };
}
  
function scrollToDiv(element){
  var headerHeight = 0;
  
  if($('.site-header').css('position') == 'fixed'|| $('.site-header__mobile-nav').css('position') == 'fixed'){
   headerHeight =  $('.site-header').outerHeight();
    console.log('has Fixed');
  }
  console.log('scrollin');
  $('html, body').animate({
        scrollTop: element.offset().top - headerHeight},
        300);
  
  console.log(element.offset().top);
  
   console.log('scrollToDiv(element)');
  
  }

  //parallax background effect
  
  function parallax(){
    console.log('parallax: ' + $('.parallax').length);
  
  if($('.parallax').length > 0){
    $('.parallax').each(function(){
      
    var scrolled = $(window).scrollTop() - $(this).offset().top;

      $(this).css('background-position',"0 "+  (scrolled * 1) + 'px');
    })
      

  $(window).scroll(function(e){
      $('.parallax').each(function(){
      
    var scrolled = $(window).scrollTop() - $(this).offset().top;

      $(this).css('background-position',"0 "+  (scrolled * 1) + 'px');
    })
  });
  }
  }
  
  function scrollLoad(objClass, shown){
    var step = shown + 1;
    var topOffset = $(objClass).offset().top;
    var height = $(objClass).height();
    var totalOffset = topOffset + height - $(window).height()*2;
    console.log('offset: ' + topOffset);
    
     var css = '<style>'+objClass+'>div:nth-child(n+'+step+')){display: none}</style>';
    
    $(window).scroll(function(){
      var top = $(window).scrollTop();
      
      console.log('compare: ' +top+'---'+ totalOffset +'shown: ' + shown +'-- total:' + $(''+objClass+'>div').length);
      
      if(top > totalOffset && $('.stamped-reviews-widget>div').length > shown ){
        
        console.log('new reviews showing: ' + $(''+objClass+'>div:hidden:not(:nth-child(n+'+( shown + step )+'))').length);
        $(''+objClass+'>div:hidden:not(:nth-child(n+'+( shown + step )+'))').slideDown(300);
        shown = shown + step;
      }
      
      height = $(objClass).height();
    totalOffset = topOffset + height - $(window).height();
    })
  }
  
  //custom modal
  
  function customModalShow(cookie, modal){
    console.log('modalClass: ' + modal.attr('class').replace(/\s/g, ''));
    if(cookie == 'cookie'){
     
      if(checkCookie(modal.attr('class').replace(/\s/g, '')) == 1){
       console.log('customModalShow('+cookie+'); opened: opened');
        
        return 'opened';
        
        
      }
      else{
        setCookie(modal.attr('class').replace(/\s/g, ''));
        
        hideScroll();
        
        fadeEffects('',modal);
        
           console.log('customModalShow('+cookie+'); opened: opening');
        
        
        $('.modal__close').click(function(){
        closeModal(modal);
        })
        console.log('customModalShow('+cookie+');opened: opening');
        
        return 'opening';
        
        
      }
      
    }
    else{
      
      hideScroll();
        
        fadeEffects('',modal);
        
           console.log('customModalShow('+cookie+');opened: opening');
        
        
        $('.modal__close').click(function(){
        closeModal(modal);
        })
        console.log('customModalShow('+cookie+'); opened: opening');
        
        return 'opening';
        
        
      
    }
    
  }
  
  function closeModal(elem){
   fadeEffects(elem, ''); 
    showScroll();
  }
  
  //smooth scroll if internal link

  $(document).on('click', 'a', function(e){
    if($(this).attr('href').indexOf('#') == 0 && $(this).attr('href').length > 1 && $($(this).attr('href')).length > 0){
       if($(e.target).is('.instafeed-overlay') || location.hash.includes("-insta-feed")){ 
        return;
      }
      e.preventDefault();

      if($('.site-header').hasClass('fixed-header')){
        var scrolltop = $($(this).attr('href')).offset().top - $('.site-header').height() - $('.about-navigation').height() + 1;
      }
      else{
        var scrolltop =   $($(this).attr('href')).offset().top - 180;
      }
      $('html, body').animate({ scrollTop: scrolltop}, 300);
      return false;
    }
  })
  
  //check if fixed elem is over static one 
  
  function checkScrollOver(elem, elem2){
    var elemOffset = elem.offset().top;
    
    if(elem2 !== undefined){
      var elem2Offset = elem2.offset().top + elem2.outerHeight();
      
     if(elem2Offset > elemOffset){
      
      console.log('checkScrollOver(elem) = 1');
     return 1; 
    }
    else{
      console.log('checkScrollOver(elem) = 0 with elemOffset = ' + elemOffset + ' and scrollTop: ' + elem2Offset);
     return 0; 
    }
    }
    else{
    if($(document).scrollTop() > elemOffset){
      
      console.log('checkScrollOver(elem) = 1');
     return 1; 
    }
    else{
      console.log('checkScrollOver(elem) = 0 with elemOffset = ' + elemOffset + ' and scrollTop: ' + $(document).scrollTop());
     return 0; 
    }
    }
  }
  
    //if element is visible on the screen
  
  function isScrolledIntoView(elem){
    var $elem = $(elem);
    var $window = $(window);

    var docViewTop = $window.scrollTop();
    var docViewBottom = docViewTop + $window.height();

    var elemTop = $elem.offset().top;
    var elemBottom = elemTop + $elem.height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}

  //hide context menu
  
  function hideContextMenu(obj){
    
     function absorbEvent_(event) {
      var e = event || window.event;
      e.preventDefault && e.preventDefault();
      e.stopPropagation && e.stopPropagation();
      e.cancelBubble = true;
      e.returnValue = false;
      return false;
    }

    function preventLongPressMenu(node) {
      node.ontouchstart = absorbEvent_;
      node.ontouchmove = absorbEvent_;
      node.ontouchend = absorbEvent_;
      node.ontouchcancel = absorbEvent_;
    }

      preventLongPressMenu(obj);
   
  }
  
  
  
  


function updateCart(elem, remove){
console.log('updateCart()');
  
  if(remove == 'remove'){
    
    var id = $(elem).parents('.item-holder').data('id');
    
    push_to_queue(id, 0);
    
    Shopify.updateAlong();
    
    $(elem).parents('.item-holder').slideUp(transition);
    
    noProducts(id);
  }
  else{
    
    var id = $(elem).parents('.item-holder').data('id');
  
    console.log('ajax-id: '+ id);
  
    setTimeout(function(){
  
    var  qty = elem.parents('.input__number-holder').find('input').val();   
    
    push_to_queue(id, qty);  
    
      if(qty == 0){
        
        $(elem).parents('.item-holder').slideUp(transition);
        
        noProducts(id);
      }
      
    Shopify.updateAlong();
    
    },300);
    
    
  }
}

function noProducts(id){
  if($('.item-holder:not([data-id="'+id+'"]):visible').length < 1){
   $('#noProducts').slideDown(transition);
  }
}


function hideAjaxCart(){
  if($('#ajaxCart').hasClass('active')){
        showScroll();
      $('#ajaxCart').removeClass('active');
            $('.site-header__cart.ajax-cart').removeClass('opened');
if(!$('.site-header').hasClass('not-transparent-on-top')){
           $('.template-index .site-header').removeClass('not-transparent');
}
}
}

function hideNav(){
 showScroll();
          $('html').removeClass('nav-opened');
          $('.mobile-nav-wrapper').removeClass('js-menu--is-open');
          $('.js-mobile-nav-toggle').removeClass('mobile-nav--close');
          if(!$('.site-header').hasClass('not-transparent-on-top')){
          $('.template-index .site-header').removeClass('not-transparent');
          }
}

function swipeFunctions(direction){
  
      if($('html').hasClass('nav-opened') && direction == 'left'){
     hideNav();
    }
      
      if($('#ajaxCart').hasClass('active') && direction == 'right'){
        hideAjaxCart();
      }
}


var direction = '';

    $("html")
    .on('mousedown touchstart', function (e) {
            xDown = e.pageX || e.originalEvent.touches[0].pageX;
            yDown = e.pageY || e.originalEvent.touches[0].pageY;
            console.log("(x,y) = (" + xDown + "," + yDown +")");
        })
        .on('mouseup touchend',function (e) {
            xUp = e.pageX || e.originalEvent.changedTouches[0].pageX;
            yUp = e.pageY || e.originalEvent.changedTouches[0].pageY;
            console.log("(x,y) = (" + xUp + "," + yUp +")");
            if (xDown != xUp || yDown != yUp) {
                console.log('Swiped');   
            }
      if(Math.abs((yDown - yUp)) > 50 || Math.abs((xDown - xUp)) > 50){
    if(Math.abs((yDown - yUp)) > Math.abs((xDown - xUp))){
        
          console.log('Vertical swipe');
        
        if(yDown > yUp){
         console.log('up');
         direction = 'up';
        }
        else{
          console.log('swipe down');
          direction = 'down' ;
        }
      }
      else{
        console.log('Horzontal swipe');
        
        if(xDown > xUp){
         console.log('swipe left');
         direction = 'left' ;
        }
        else{
          console.log('swipe right');
          direction = 'right' ;
        }
      }
      console.log('swipe: xDown: '+ xDown + '; yDown:' + yDown + '; xUp:' + xUp + '; yUp:' + yUp);
      }
      else{
       console.log('no swipe detected');
        direction = 'no-swipe';
      }
      
  console.log('direction: ' + direction);
      swipeFunctions(direction);
      
        })
    ;

function renderCartPopup(variantId, qty, props){
  setTimeout(function(){
  jQuery.getJSON('/cart.js', function(cart) {
    
    for(var i=0; i<cart.items.length; i++){
      var item = cart.items[i];
    
      if(item.id == variantId){
      
        var parent = $('.cart-popup-wrapper');
    
    parent.find('[data-cart-popup-title]').html(item.title);
        parent.find('[data-cart-popup-quantity]').html(qty);
        
        if(parent.find('[data-cart-popup-image-wrapper] img').length > 0){
          parent.find('[data-cart-popup-image-wrapper] img').attr('src', item.featured_image.url);
        }
        else{
        parent.find('[data-cart-popup-image-wrapper]').append('<img src="'+item.featured_image.url+'" alt="10875 Cargo Train CS PK 2 Development" class="cart-popup-item__image" data-cart-popup-image="">');
        }
        parent.find('.cart-popup-item__image-wrapper').removeClass('hide');
        
        parent.find('[data-cart-popup-cart-quantity]').html(cart.item_count);
        
        parent.find('[data-cart-popup-product-details]').html('');
        
        console.log(props);
        
        $.each(props, function( key, value) {
          console.log('key: ' + key);
          if(key.indexOf('_') != 0){
     parent.find('[data-cart-popup-product-details]').append('<li class="product-details__item product-details__item--property"><span class="product-details__property-label">'+key+': </span>'+value+'</li>')
          }
          })
          
        
        i = cart.items.length;
      }
    }
        $('.cart-popup-wrapper').removeClass('cart-popup-wrapper--hidden');
    
    parent.find('[data-cart-popup-close]').one('click', function(){
    parent.addClass('cart-popup-wrapper--hidden');
    })
  }, 600)
  });
    
}

$.fn.outerHTML = function(){
 
    // IE, Chrome & Safari will comply with the non-standard outerHTML, all others (FF) will have a fall-back for cloning
    return (!this.length) ? this : (this[0].outerHTML || (
      function(el){
          var div = document.createElement('div');
          div.appendChild(el.cloneNode(true));
          var contents = div.innerHTML;
          div = null;
          return contents;
    })(this[0]));
 
}

function isiPhone(){
    return (
        (navigator.platform.indexOf("iPhone") != -1) ||
        (navigator.platform.indexOf("iPod") != -1)
    );
}

function isLetter(str) {
  return str.length === 1 && str.match(/[a-z]/i);
}


function quickAddToCart(elem){

    var variantId = elem.data('id');

    var formData = new FormData();
    
 formData.append('form_type', 'product');
 formData.append('utf8', '✓');
 formData.append('id', variantId);

    console.log(formData.entries());
    $.ajax({
        type: "POST",
        url: '/cart/add',
      processData: false, contentType: false,
        data: formData, // serializes the form's elements.
        success: function (data) {
          console.log("we made it!");

          $('.quick-add-holder').removeClass('show-variants');
          document.documentElement.dispatchEvent(
            new CustomEvent("product:added", {
              bubbles: true, 
              detail: {
                quantity: 1
              }
            })
          );
          
        }
      });
  
}

document.documentElement.style.setProperty('--announcement-bar-height', document.getElementById('shopify-section-announcement').offsetHeight + 'px');
document.documentElement.style.setProperty('--bottom-announcement-bar-height', document.getElementById('shopify-section-bottom-announcement').offsetHeight + 'px');
/*
    function reviewsAppend(){

      var reviewsHTML = $('#reviewsAppend').html().replace(/rawscript/g, 'script');
      $('body').append(reviewsHTML);
    }
*/
$(document).ready(function(){
  
  if(isiPhone()){
   $('html').addClass('ios-user');
}
  if ( /^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
  
   $('html').addClass('safari-user');
  }
  
   $(document).on('click', '.dynamic-add-to-cart', function(){
  
  var id = $(this).data('id');
    
    push_to_queue(id, 1);
    
    Shopify.moveAlong();
   
     setTimeout(function(){
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
  bubbles: true
  }));
        
        if($('#shopify-section-cart-template').length > 0){
          $('#modal-cart-upsell .modal__close').trigger('click');
          
      $("html, body").animate({ scrollTop: 0 }, 300);
        }
      }, 600);
  });
  
    $(document).on("DOMSubtreeModified",'#sidebar-cart',function(){
    console.log($(this).find('.Cart__ShippingNotice ').html());
    var noticeHtml = $(this).find('.Cart__ShippingNotice').html();
    $('.FreeShippingNotice').html(noticeHtml);
  })

    
    $('.Collapsible__Button.horizontal-button').click(function(){ 

if(!$(this).hasClass('active')){
var parent = $(this).parents('.Product__Tabs');
var handle = $(this).data('handle');

parent.find('.Collapsible__Button.horizontal-button').removeClass('active');
$(this).addClass('active');

parent.find('.Collapsible__Inner').removeClass('active').slideUp(300);
parent.find('.Collapsible__Inner[data-parent="'+ handle +'"]').addClass('active').slideDown(300);

}
})
      $('[data-section-type="announcement-bar"]').each(function(){

        
      var index = 1;
        var parent = $(this);
        var time = parent.data('time');
        setInterval(function(){
        
          index++;
          
          if(parent.find('.AnnouncementBar__Content[data-index="'+index+'"]').length == 0){
            
           index = 1;
          }
          
           parent.find('.AnnouncementBar__Content:not([data-index="'+index+'"])').slideUp(300);
            parent.find('.AnnouncementBar__Content[data-index="'+index+'"]').slideDown(300);
          
        }, time)
        
      })
setTimeout(function(){
$('.formScript').each(function(){
  var formHtml = $(this).html();
  $(this).before(formHtml);
  
})
},2000)

if($('.whatsapp-link').length > 0){
  console.log('test line 1');
  if($('.whatsapp-link').data('text').indexOf('/url/') > -1){
  console.log('test line 2');
      var currLoc = window.location.href;
    if(window.location.href.indexOf('?') > -1){
      currLoc = window.location.href.split('?');
      currLoc = currLoc[0];
    }
    var editUrl = $('.whatsapp-link').data('href') + $('.whatsapp-link').data('text').replace('/url/', currLoc);
    $('.whatsapp-link').attr('href', editUrl);
  }
}
var initialLoad = 0;

  $( window ).on( "load",function(){
    initialLoad = 1
  })
var lastScrollTop = $('.shopify-section--header').offset().top;
$(window).scroll(function(event){
  if(initialLoad == 1){
  console.log('window scrolled');
   var st = $(this).scrollTop();
   if (st > lastScrollTop){
       $('html').addClass('scrolled');
   } else {
       $('html').removeClass('scrolled');
   }
   lastScrollTop = st;
  }
});


  $(document).on('click','.quick-add-trigger', function(e){
console.log('quick add triggered');
    e.preventDefault();
    if($(this).parents('.quick-add-holder').length == 0){
      var parent = $(this).parents('.ProductItem').find('.quick-add-holder');
    }
    else{
      var parent = $(this).parents('.quick-add-holder');
    }
    

    if($(this).hasClass('single-variant')){
      console.log('single variant there');
      quickAddToCart($(this));
    }
    else{
      parent.addClass('show-variants');
    }
  })

  $(document).on('click', '.quick-add-variant', function(e){
    
    console.log('should add it');
    e.preventDefault();
    if(!$(this).hasClass('disabled')){
    quickAddToCart($(this));
    }
  })


           console.log('currency is: ', $('button[aria-controls="header-currency-popover-0"]').data('currency'));

  if($('button[aria-controls="header-currency-popover-0"]').data('currency') == 'GBP'){
    $('html').addClass('free-shipping-active');
  }
})